import { FormGroup } from '@/components/element/Form/FormGroup';
import mfLogoSvg from '@/assets/img/mf_logo.svg';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useParams } from 'react-router-dom';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { useCreateMoneyForwardBilling } from '@/hooks/api/1971_create_mf_billing';
import { useInvoiceTaskDocumentsInvalidate } from '@/hooks/api/1900_invoice_task_documents';
import { useEffect } from 'react';
import { toastApiError } from '@/lib/toast';

export const MoneyForwardForm = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { invoiceTask: task } = useCurrentInvoiceTask();
  const { mutate, data, isPending, error } = useCreateMoneyForwardBilling();
  const { invalidate: invalidateInvoiceTaskDocuments } = useInvoiceTaskDocumentsInvalidate({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    sales_order_id: Number(sales_order_id),
    task_id: task!.id,
  });

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  useEffect(() => {
    if (data) invalidateInvoiceTaskDocuments();
  }, [data]);

  const onCreateClick = () => {
    mutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: Number(sales_order_id),
      task_id: task!.id,
    });
  };

  if (_w_!.money_forward_setting) {
    return (
      <div className="d-flex w-100">
        <FormGroup label="ファイルを作成" required={true} classes={'me-2 flex-1'}>
          <div className="d-flex align-items-center" style={{ height: 40 }}>
            <img src={mfLogoSvg} style={{ display: 'block', height: 30 }} />
          </div>
        </FormGroup>
        <div className="form-group flex-shrink-0">
          <label> </label>
          <button className="btn w-100 btn-icon bg-gradient-dark" onClick={onCreateClick}>
            <i className="fa fa-plus"></i>追加
          </button>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
